import * as React from 'react';
import styled from 'styled-components';
import { ILongProcess } from '../../../data/types';
import { LinearLoading } from '../loading/LinearLoading';

export const LongProcessModal = ({
  completed,
  total,
  message,
}: ILongProcess): React.ReactElement => {
  return (
    <OverlayContainer>
      <ContentContainer>
        <Content>
          <h1>Processing</h1>
          <h5>
            {completed} / {total}
          </h5>
          <ProcessingMessage>{message}</ProcessingMessage>
          <ProcessingIndicator>
            <LinearLoading />
          </ProcessingIndicator>
        </Content>
      </ContentContainer>
    </OverlayContainer>
  );
};

const OverlayContainer = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 1000;
  background: var(--color-card-background);
  border-radius: 10px;
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

const Content = styled.div`
  padding: 20px;
  text-align: center;
  width: 80%;
`;

const ProcessingIndicator = styled.div`
  margin-top: 20px;
  min-height: 50px;
`;

const ProcessingMessage = styled.div``;
